import * as React from 'react'
import { useCallback, useContext } from 'react'
import Clickable from 'components/Common/Clickable'
import InlineIcon from 'components/utils/InlineIcon'
import ModalContext from 'contexts/ModalContext'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import MaldivesReturnForFreeInfoModal from 'components/MaldivesDirect/MaldivesReturnForFreeInfoModal'
import { FormattedMessage, useIntl } from 'react-intl'

function ReturnFareFreeLabel() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const handleInfoClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    event.stopPropagation()
    showModal(<MaldivesReturnForFreeInfoModal />)
  }, [showModal])

  return (
    <BodyTextBlock
      variant="medium"
      weight="bold"
      colour="lux-plus"
      startIcon={<SolidFireIcon />}
    >
      <FormattedMessage
        id="pIOxPw-SIUKc0IBvXxf6"
        defaultMessage="Return for FREE with LuxPlus+ {infoIcon}"
        description="Promotional callout shown when LuxPlus members get the Maldives charter return economy flight fare for free, followed by an icon opening the explainer"
        values={{
          infoIcon: (
            <Clickable
              onClick={handleInfoClick}
              aria-label={intl.formatMessage({
                id: 'cOz22e4pg-jsCM_tpAzb',
                defaultMessage: 'How the return for free flight sale works',
                description: 'Accessible label for the icon that opens the Maldives return for free campaign explainer',
              })}
            >
              <InlineIcon Icon={LineInfoCircleIcon} colour="normal-contrast" />
            </Clickable>
          ),
        }}
      />
    </BodyTextBlock>
  )
}

export default ReturnFareFreeLabel
